import { useAppContext } from "@/contexts/AppContext";
import { Alert, MagicLink, PageContainerNewLayout } from "@disasterscience/scaffoldy";

export const Protected = (props: { children: React.ReactNode }) => {
    const { isLoggedIn } = useAppContext();

    if (!isLoggedIn) {
        return (
            <>
                <PageContainerNewLayout>
                    <Alert variant="warning" className="tw:mt-4">
                        You must be logged in to access this content.{" "}
                        <MagicLink href="/ux/login">Login</MagicLink>
                    </Alert>
                </PageContainerNewLayout>
            </>
        );
    }

    return <>{props.children}</>;
};
